import e from "./_baseGetTag.js";
import r from "./isLength.js";
import o from "./isObjectLike.js";
var g = e, b = r, c = o, T = "[object Arguments]", j = "[object Array]", n = "[object Boolean]", i = "[object Date]", y = "[object Error]", s = "[object Function]", p = "[object Map]", A = "[object Number]", f = "[object Object]", u = "[object RegExp]", m = "[object Set]", l = "[object String]", d = "[object WeakMap]", I = "[object ArrayBuffer]", k = "[object DataView]", L = "[object Float32Array]", U = "[object Float64Array]", _ = "[object Int8Array]", h = "[object Int16Array]", v = "[object Int32Array]", w = "[object Uint8Array]", x = "[object Uint8ClampedArray]", B = "[object Uint16Array]", F = "[object Uint32Array]", a = {};
a[L] = a[U] = a[_] = a[h] = a[v] = a[w] = a[x] = a[B] = a[F] = !0;
a[T] = a[j] = a[I] = a[n] = a[k] = a[i] = a[y] = a[s] = a[p] = a[A] = a[f] = a[u] = a[m] = a[l] = a[d] = !1;
function M(t) {
  return c(t) && b(t.length) && !!a[g(t)];
}
var E = M;
export {
  E as default
};
//# sourceMappingURL=_baseIsTypedArray.js.map
